import { useMutation } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';
import { IPublishDraftJobPostPayload } from '../types';

export const usePublishDraftJobPost = () => {
  return useMutation({
    mutationFn: (payload: IPublishDraftJobPostPayload) => {
      return PermanentJobsService.publishDraftJobPost(payload);
    },
  });
};
